/*************************
 * @license
 * Copyright 2024 Myenergi Ltd. All rights reserved.
 * No part of this work may be reproduced, stored in a retrieval system of any nature, or transmitted, in any form or by any means without the prior written permission of Myenergi Ltd., the copyright owner.
 * If any unauthorised acts are carried out in relation to this copyright work, a civil claim for damages may be made and/or a criminal prosecution may result.
 *************************/
import { Permission, DeviceName } from "models/graphql";

export interface DeviceConfigSubMenu {
  i18n: string;
  requiredPermission: Permission;
  type: DeviceConfigSubMenuType;
  deviceTypes: Set<DeviceName>;
}

export enum DeviceConfigSubMenuType {
  basicSettings = "basicSettings",
  advancedSettings = "advancedSettings",
  engineeringMode = "engineeringMode",
  services = "services",
  relaysAndSensors = "relaysAndSensors",
  expansionCard = "expansionCard",
  ocppSettings = "ocppSettings",
  errorsAndWarnings = "errorsAndWarnings",
}

const deviceConfigSubMenus = [
  {
    type: DeviceConfigSubMenuType.basicSettings,
    i18n: "hubDetailsPage.hub.deviceConfigNavbar.basicSettings",
    requiredPermission: Permission.hubDetailsView,
    deviceTypes: new Set([
      DeviceName.zappi1,
      DeviceName.zappi2,
      DeviceName.rapidZappi,
      DeviceName.eddi,
      DeviceName.eddiPlus,
      DeviceName.libbi,
    ]),
  },
  {
    type: DeviceConfigSubMenuType.advancedSettings,
    i18n: "hubDetailsPage.hub.deviceConfigNavbar.advancedSettings",
    requiredPermission: Permission.hubDetailsView,
    deviceTypes: new Set([
      DeviceName.zappi1,
      DeviceName.zappi2,
      DeviceName.rapidZappi,
      DeviceName.eddi,
      DeviceName.eddiPlus,
      DeviceName.libbi,
    ]),
  },
  {
    type: DeviceConfigSubMenuType.engineeringMode,
    i18n: "hubDetailsPage.hub.deviceConfigNavbar.engineeringMode",
    requiredPermission: Permission.hubDetailsView,
    deviceTypes: new Set([DeviceName.zappi2, DeviceName.rapidZappi]),
  },
  {
    type: DeviceConfigSubMenuType.ocppSettings,
    i18n: "hubDetailsPage.hub.deviceConfigNavbar.ocpp",
    requiredPermission: Permission.ocppDeviceEdit,
    deviceTypes: new Set([DeviceName.zappi2, DeviceName.rapidZappi]),
  },
  {
    type: DeviceConfigSubMenuType.services,
    i18n: "hubDetailsPage.hub.deviceConfigNavbar.services",
    requiredPermission: Permission.hubDetailsView,
    deviceTypes: new Set([]),
  },
  {
    type: DeviceConfigSubMenuType.relaysAndSensors,
    i18n: "hubDetailsPage.hub.deviceConfigNavbar.relaysAndSensors",
    requiredPermission: Permission.hubDetailsView,
    deviceTypes: new Set([]),
  },
  {
    type: DeviceConfigSubMenuType.expansionCard,
    i18n: "hubDetailsPage.hub.deviceConfigNavbar.expansionCard",
    requiredPermission: Permission.hubDetailsView,
    deviceTypes: new Set([DeviceName.eddi, DeviceName.eddiPlus]),
  },
];

export default deviceConfigSubMenus;
